export class GetTransactionDetailsCommandReqData {
    public transactionId: string = null;
    public limit: number = 10;
    public offset: number = 0;
}
